import { useEffect } from "react";
const Redirect = () => {
  useEffect(() => {
    window.location.href = "https://hyperauth.app/";
  }, []);
};
export default Redirect;
